<template>
  <div class="d-flex flex-column">
    <div class="filter-component-container d-flex align-center flex-fill mb-2">
      <div class="d-flex flex-column justify-content-center mr-2 m-basis-40">
        <span class="font-inter titulo-5"> 
          Asignatura
        </span>
        <v-select
          dense
          v-model="subject"
          :items="user.subjects"
          outlined
          placeholder="Asignatura"
          hide-details="auto"
          :item-text="item => capitalizeFirstLetter(item.name)"
          :item-value="item => item.subjectId"
        ></v-select>
      </div>


      <div class="d-flex flex-column justify-content-center mr-2 m-basis-40">
        <span class="font-inter titulo-5"> 
          Unidad
        </span>          
        <v-select
          dense
          v-model="unit"
          outlined
          placeholder="Unidad"
          hide-details="auto"
          :items="lessonInfo.unitList"
          :item-text="item => capitalizeFirstLetter(item.name)"
          :item-value="item => item.unitId"
      ></v-select>
      </div>

      <div class="d-flex flex-column justify-content-center mr-2 m-basis-40">
        <span class="font-inter titulo-5"> 
          Mes
        </span>          
        <v-select
          dense
          :items="this.meses"
          v-model="mes"
          :item-text="item => item.name"
          :item-value="item => item.id"
          outlined
          placeholder="Mes"
          hide-details="auto"
        ></v-select>
      </div>

      <div class="d-flex flex-column justify-content-center mr-2 m-basis-40">
        <span class="font-inter titulo-5"> 
          Título
        </span>          
        <v-text-field
          placeholder="Titulo"
          v-model="searchText"
          @keyup="inputSearch"
          hide-details="auto"
          outlined
          dense
        ></v-text-field>
      </div>

      <div class="ml-2 mt-auto m-basis-90 d-flex justify-content-end">
        <v-btn dark class="primary-btn text-capitalize text-center" @click="search()" height='40px'>
          <v-icon> mdi-magnify </v-icon>
          <span class="hide-sm">Buscar</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { debounce } from "vue-debounce";

export default {
  name: "RomaFilter",
  props: ["options"],
  data() {
    return {
      searchText: '',
      subject: "",
      unit:"",
      items: [],
      mes: "",
      meses: [{id:1,name:'Enero'},{id:2,name:'Febrero'},{id:3,name:'Marzo'},{id:4,name:'Abril'},
	   {id:5,name:'Mayo'},{id:6,name:'Junio'},{id:7,name:'Julio'},{id:8,name:'Agosto'},
	   {id:9,name:'Septiembre'},{id:10,name:'Octubre'},{id:11,name:'Noviembre'},{id:12,name:'Diciembre'}],
      showFilter: false,
      defaultOptions: [],
    };
  },
  computed: {
    ...mapGetters({
      lessonInfo: "getLessonInformation",
      user: "getUserData",
    }),
    getOptions() {
      return this.options ? this.options : this.defaultOptions;
    },
  },
  components: {},
  methods: {
    ...mapActions({
      toastSuccess: "toastSuccess",
      toastError: "toastError",
      getLessonInfo: "actionGetFilterInformationLesson",
      actionFilterLesson: "actionFilterLesson",
    }),
    showFilterModal() {
      this.showFilter = !this.showFilter;
      this.getLessonInfo({ institutionId: this.user.institutionContext.institutionId });
    },
    capitalizeFirstLetter(string) {
            const text =
                string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            return text;
    },
    inputSearch: debounce(function(e) {
      this.search();
    }, 700),
     
     cancelSearch() {
        	this.subject = "";
        	this.title = "";
            this.unit = "";
            this.searchText = "";
            this.hideFilter();
      },     
      hideFilter() {
            this.showFilter = false;
      },      
     search() {
       
      const institutionId = this.user.institutionContext.institutionId
        ? `?institutionId=${this.user.institutionContext.institutionId}`
        : "";
      const personId = this.user.personId
        ? `&personId=${this.user.personId}`
        : "";
        
      const subjectId = this.subject ? `&subjectId=${this.subject}` : ""; 
      const unitId = this.unit ? `&unitId=${this.unit}` : "";
      const mesValue = this.mes ? `&month=${this.mes}` : "";
      const pageNumber = 0;
      const pageSize = 8;
      const arrayQuery = [];
      for (const item of this.options) {
        if (item.type !== "spacer") {
          if (item.type === "text") {
            item.model.text
              ? arrayQuery.push(`&${item.query}${item.model.text}`)
              : "";
          } else {
            item.model.id !== 0
              ? arrayQuery.push(`&${item.query}${item.model}`)
              : "";
          }
        }
      }
      const query =
        arrayQuery.join("") +
        `?&pageNumber=${pageNumber}&pageSize=${pageSize}` + (this.searchText ? `&title=${this.searchText}` : '') + `&sectionId=${this.user.section.sectionId}${subjectId}${unitId}${mesValue}`;
      const pagination = "";
      this.actionFilterLesson(query);
      // this.toastSuccess({ message: "Busqueda correcta" });
      //this.hideFilter();
    },
    onClickOutside() {
      // this.showFilter = !this.showFilter;
    },
  },
};
</script>

<style lang="scss">
.icon-search:before,
.icon-search:after {
  content: url("../../assets/icons/magnify.svg");
  padding-top: 5px;
  padding-right: 5px;
}
.filter {
  .filter-container {
    position: absolute;
    z-index: 2;
    padding: 35px 41px 35px 41px;
    max-width: 910px;
    min-width: 910px;
    top: calc(10% + 0.5rem);
    left: 50%;
    transform: translateX(-50%);
    right: 0;
    background: #ffffff 0 0 no-repeat padding-box;
    box-shadow: 0 3px 6px #00000052;
    border-radius: 15px;
    opacity: 1;
  }

  .icon-search {
    color: #72237c;
  }

  .theme--light.v-icon {
    color: #72237c;
  }

  .v-input__control {
    height: 50px !important;
  }

  .filter-down {
    border-radius: 50%;
    width: 28px;
    height: 28px;
  }

  .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 47px !important;
    height: 47px;
  }

  .btn-search {
    margin-top: 15px;
    width: 181px;
    height: 65px !important;
    background: #ffffff 0 0 no-repeat padding-box;
    box-shadow: 0 6px 15px #00000029;
    border-radius: 50px;
    opacity: 1;
    color: #580463;
    text-transform: capitalize !important;
    i {
      margin-left: 15px;
      font-size: 1.85em !important;
    }
  }

  .input-filter {
    height: 47px !important;
    margin-bottom: 15px !important;
    background: #ffffff 0 0 no-repeat padding-box !important;
    border: 1px solid #d6d6d6 !important;
    border-radius: 24px !important;
    opacity: 1 !important;
    line-height: 26px !important;
    padding: 4px 0;
  }

  .search-input {
    border-radius: 32px;
    opacity: 1;
  }

  .padding-input {
    padding: 0 5px 0 5px !important;
  }

  .container-inputs {
    padding: 10px 0 0 0 !important;
  }

  .col-63 {
    /*max-width: 75%;*/
  }
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: 40px !important; 
    }

  @media only screen and (max-width: 645px) and (min-width: 480px) {
    .filter-container {
      padding: 35px 41px 35px 41px;
      max-width: 90%;
      top: 270px;
      width: 100%;
      min-width: 320px;
      left: 220px;
    }
  }
}
</style>
